(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('siteUpdateAction', {
      controller: Controller,
      templateUrl: 'actions/site/update/update-site.action.html',
      bindings: {
        site: '<',
        siteId: '<',
        then: '&',
        catch: '&'
      }
    });
}());
